// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getVideoCreatorListFailed, getVideoCreatorListRequested, getVideoCreatorListSucceeded } from './select-video-creator.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectVideoCreatorListResponse } from './select-video-creator.selectors';

@Injectable()
export class SelectVideoCreatorEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getVideoCreatorListRequested),
      withLatestFrom(this.store.select(selectVideoCreatorListResponse)),
      filter(([, response]) => response == null),
      switchMap(() => this.service.getVideoCreatorList()
        .pipe(
          map((response) => getVideoCreatorListSucceeded({response})),
          catchError(() => of(getVideoCreatorListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
